import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import translate from 'admin-on-rest/lib/i18n/translate';
import FlatButton from "material-ui/FlatButton";
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    button: {overflow: 'inherit'},
};

const ViewTextButtonWithType = ({
                                    basePath = '',
                                    label = 'aor.action.show',
                                    record = {},
                                    translate,
                                }) => (
    <FlatButton
        primary
        label={label && translate(label)}
        icon={<ContentView/>}
        containerElement={
            <Link to={`${basePath}/${encodeURIComponent((record) ? record.type : '')}/${(record) ? record.id : ''}/show`}/>
        }
        style={styles.button}
    />
);

ViewTextButtonWithType.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
    translate: PropTypes.func,
};

ViewTextButtonWithType.defaultProps = {
    style: {padding: 0},
};

export default translate(ViewTextButtonWithType);



// WEBPACK FOOTER //
// ./src/Fuse/buttons/ViewTextButtonWithType.js